import { render } from "./Decline.vue?vue&type=template&id=938c1098&scoped=true&ts=true&lang=pug"
import script from "./Decline.vue?vue&type=script&lang=ts"
export * from "./Decline.vue?vue&type=script&lang=ts"

import "./Decline.vue?vue&type=style&index=0&id=938c1098&scoped=true&lang=css"

import exportComponent from "E:\\UiDesk\\laragon-5.0.0\\www\\click-to-call\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-938c1098"]])

export default __exports__